<script setup lang="ts">
  import { computed } from 'vue';
  import { formatNumber } from '../model/format';
  import VariationBadge from './VariationBadge.vue';
  import WidgetCard from './WidgetCard.vue';

  interface Props {
    title: string;
    value: number | null;
    variationPct: number | null;
    comparisonLabel: string;
    icon?: string | object;
    iconAlt?: string;
    loading?: boolean;
    hasData?: boolean;
    valueSuffix?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    icon: undefined,
    iconAlt: '',
    loading: false,
    hasData: true,
    valueSuffix: undefined,
  });

  const formattedValue = computed(() => {
    if (props.value === null) return '-';
    const value = formatNumber(props.value);
    return props.valueSuffix === undefined ? value : `${value} ${props.valueSuffix}`;
  });
</script>

<template>
  <WidgetCard
    :title="props.title"
    :icon="props.icon"
    :icon-alt="props.iconAlt"
    :loading="props.loading"
    :has-data="props.hasData"
    skeleton="stat"
  >
    <div class="flex h-full flex-col justify-end gap-5">
      <p
        data-testid="stat-card-value"
        class="text-3xl/9.5 font-bold text-gray-07"
      >
        {{ formattedValue }}
      </p>
      <VariationBadge
        :variation-pct="props.variationPct"
        :comparison-label="props.comparisonLabel"
        neutral-when-null
      />
    </div>
  </WidgetCard>
</template>
